import { createDCHook, collapseDataFromCall } from '../client';
import {
  getPeriodicEnergyBillBreakdown,
  getEnergyBillBreakdown,
  getEnergyBillBreakdownForAddress,
} from '../services/EnergyBillBreakdownService';

export const useEnergyBillBreakdownGetPeriodicEnergyBillBreakdown = createDCHook(
  'getPeriodicEnergyBillBreakdown',
  collapseDataFromCall(getPeriodicEnergyBillBreakdown),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);

export const useEnergyBillBreakdownGetEnergyBillBreakdown = createDCHook(
  'getEnergyBillBreakdown',
  collapseDataFromCall(getEnergyBillBreakdown),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
  { maxAge: 300000 },
);

export const useEnergyBillBreakdownGetEnergyBillBreakdownForAddress = createDCHook(
  'getEnergyBillBreakdownForAddress',
  collapseDataFromCall(getEnergyBillBreakdownForAddress),
  { injectables: ['label', 'customerId', 'accountId', 'businessUnit'], flattenData: true },
);
